import moment from 'moment';

export const genERequestNo = ({
  policyNumber = '',
}: {
  policyNumber: string;
}) => {
  return `${moment().format('YYYYMMDDHHmmss')}${policyNumber.substring(
    policyNumber.length - 7,
  )}`;
};
